import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApi } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
const AccountsList = ({ setDataSourceUom, dataSourceUom, t, form }) => {
  // console.log('dataSourceUom',dataSourceUom);

  const { companyName } = useSelector((state) => state.user);
  const { data: Account } = useQuery({
    queryKey: [queryKeys.getSearchAccount],
    queryFn: () => getSearchApi('Account'),
    keepPreviousData: true,
  });
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.Account,
      dataIndex: 'account',
      render: (text, record, index) => (
        <Select
          showSearch
          // placeholder={t.uom}
          placeholder={t.Account}
          style={{ width: '300px' }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={Account?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          value={record.account}
          onChange={(value) => {
            const newDataSource = [...dataSourceUom];
            newDataSource[index] = {
              ...newDataSource[index],
              account: value,
            };
            setDataSourceUom(newDataSource);
          }}
        />
      ),
    },
    // {
    //   title: t.company,
    //   dataIndex: 'company',
    //   render: (text, record, index) => (
    //     <Input
    //     placeholder={t.company}
    //     style={{ width: '300px' }}
    //     value={record.company}
    //     disabled
    //   />
    //   ),
    // },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      company: companyName,
    };
    setDataSourceUom((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceUom.filter((item) => item.key !== key);
    setDataSourceUom(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceUom}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default AccountsList;
